export default {
    computed: {
        inputVal: {
            get() {
                const path = this.path ? this.path : this.attributes.path;
                if (path) {
                    return this.$getNestedPropVal(this.$store.getters, path.split('.'));
                }
                return null;
            },
            set(val) {
                const path = this.path ? this.path : this.attributes.path;
                if (path) {
                    this.$store.commit('setProp', { path, value: val });
                }
            },
        },
    },
};
